/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';

import { getHeadboardApprover, getWorkReportsApprover } from '../services/workReport';
import { useFilterContext } from '../context/FilterContext';
import { bulidFilterWorkReportRequest } from '../page/ServiceRequest/FilterServiceRequest/utils/filterServiceRequestUtils';
import { formatFullDate, formatsEnum } from '../utils/formatUtils';
import {
  adapterResponseBoard,
  adapterResponseWorkReport
} from '../page/ApproverWorkReport/ApproverWorkReportAdapter';

import useToast from './useToast';

const useApproverWR = () => {
  const [data, setData] = useState(null);
  const [dateWorkReport, setDateWorkReport] = useState(
    formatFullDate(new Date(), formatsEnum.FORMAT_DATE_2)
  );
  const [headBoard, setHeadBoard] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [loading, setLoading] = useState(false);
  const isFirstRenderFilter = useRef(true);
  const isFirstRenderPageIndex = useRef(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isOrderByUbication, setIsOrderByUbication] = useState(true);
  const [size, setSize] = useState(10);

  const { filter } = useFilterContext();

  const { setNewToast } = useToast();

  const getWorkReport = async (paramsSearch) => {
    try {
      setLoading(true);
      const response = await getWorkReportsApprover(paramsSearch, dateWorkReport, isPending);
      const responseHeadBoard = await getHeadboardApprover(dateWorkReport, isPending);

      setHeadBoard(adapterResponseBoard(responseHeadBoard));
      setLoading(false);
      setData(adapterResponseWorkReport(response));
    } catch (err) {
      setLoading(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const handlePageSize = (pageSizeParam) => {
    setPageSize(pageSizeParam);
  };

  const fetchData = ({ pageNumber } = { pageNumber: 1 }) => {
    const configWorkReport = {
      pageNumber,
      pageSize,
      agrupaPorUbicacion: isOrderByUbication
    };

    const { filters } = bulidFilterWorkReportRequest({
      filters: filter,
      paginationData: configWorkReport
    });

    getWorkReport(filters);
  };

  const handleGoFirstLastDay = (firstDay = false) => {
    if (firstDay) {
      setDateWorkReport(headBoard?.primeraFecha || data?.primerFecha);
    } else {
      setDateWorkReport(headBoard?.ultimaFecha || data?.ultimaFecha);
    }
  };

  const handleOrderByUbication = (isOrderByUbicationParam) => {
    setIsOrderByUbication(isOrderByUbicationParam);
  };

  useEffect(() => {
    if (isFirstRenderPageIndex.current) {
      isFirstRenderPageIndex.current = false;

      return;
    }
    fetchData({
      pageNumber: pageIndex + 1,
      pageSize: size
    });
  }, [pageIndex]);

  useEffect(() => {
    if (isFirstRenderFilter.current) {
      isFirstRenderFilter.current = false;

      return;
    }
    setPageIndex(0);
    fetchData({
      pageNumber: pageIndex + 1,
      pageSize: size
    });
  }, [filter, dateWorkReport, isPending, size, isOrderByUbication, pageSize]);

  return {
    data,
    dateWorkReport,
    fetchData,
    headBoard,
    isPending,
    loading,
    pageIndex,
    size: pageSize,
    setSize,
    setDateWorkReport,
    setIsPending,
    setPageIndex,
    handleGoFirstLastDay,
    handlePageSize,
    handleOrderByUbication,
    isOrderByUbication
  };
};

export default useApproverWR;
